import {
  colors,
  VStack,
  useResponsive,
  HStack,
  NextLink,
  LargeButton,
  LARGEL_BUTTON_TYPE,
} from "goi_common";
import SeaBurialTitleSection from "./components/SeaBurialTitleSection";

import { Box } from "@chakra-ui/react";
import SeaBurialTabSection from "./components/SeaBurialTabSection";

export default function FacilitiesRegionSeaBurialContainer({
  district,
  regionSeaBurial,
}: {
  district: string;
  regionSeaBurial: Array<any>;
}) {
  return (
    <VStack width="100%" alignItems="center">
      <VStack width="100%" maxWidth="480px" padding="24px 0">
        <SeaBurialTitleSection
          district={district}
          description={
            <>
              <span className="orange650">{regionSeaBurial.length}</span>개의 바다장이 있어요.
            </>
          }
        />
        <SeaBurialHeadCTA />
        <SeaBurialTabSection
          regionSeaBurial={regionSeaBurial}
          district={district}
          eventPath="sea_burial_region"
        />
      </VStack>
    </VStack>
  );
}

function SeaBurialHeadCTA() {
  const { isBiggerThanMd } = useResponsive();
  return (
    <VStack gap="24px" padding={isBiggerThanMd ? "40px 0" : "40px 24px"}>
      <VStack
        padding="24px 16px"
        background={colors.gray50}
        borderRadius="10px"
        border={`1px solid ${colors.gray200}`}
        gap="7px"
      >
        <Box className="subtitle_14_sb" color={colors.gray600} as="h2">
          장지 예상 비용 범위
        </Box>
        <HStack alignItems="center" gap="4px" padding="0 0 16px">
          <Box as="p" className="subtitle_18_b">
            300,000
          </Box>
          <Box as="p" className="caption_12_b">
            원
          </Box>
          <Box as="p" className="subtitle_18_b">
            ~
          </Box>
          <Box as="p" className="subtitle_18_b">
            1,300,000
          </Box>
          <Box as="p" className="caption_12_b">
            원
          </Box>
        </HStack>
        <Box className="body_14_l gray800" as="p">
          저렴한 합동 바다장부터 비싼 독선 바다장까지 금액이 천차만별이기 때문에, 가격과 조건을 잘
          따져서 알아보는 것이 중요해요.
        </Box>
      </VStack>
      <NextLink
        href="/match/request/"
        event={{
          newGtm: { path: "sea_burial_region", trigger_and_target: "CTA-uv_match_request" },
        }}
      >
        <LargeButton className="subtitle_16_sb" buttonType={LARGEL_BUTTON_TYPE.ORANGE}>
          상세 비용 알아보기
        </LargeButton>
      </NextLink>
    </VStack>
  );
}
